import { api } from "services";
import { download, getFileSize } from "./misc/misc";
import { handleFetchError } from "./errors";
import { dateFormat } from "./date";

/**
 * Скачивание файла
 * @param endpoint URL для запроса файла
 * @param autoDownload Автоматически скачивать файл после получения (по умолчанию: false)
 * @returns Возвращает имя файла и URL для скачивания
 */
export const downloadFileBlob = async (endpoint: string, autoDownload = false) => {
  try {
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${api.getToken()}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.json();
      throw errorText;
    }

    let filename = "";
    const contentDisposition = response.headers.get("Content-Disposition");
    if (contentDisposition) {
      const filenameRFC5987Regex = /filename\*=UTF-8''(.+?)($|;)/;
      const filenameRFC5987Match = contentDisposition.match(filenameRFC5987Regex);
      if (filenameRFC5987Match?.[1]) {
        filename = decodeURIComponent(filenameRFC5987Match[1]);
      } else {
        const simpleFilenameRegex = /filename="?(.+?)"?($|;)/;
        const simpleFilenameMatch = contentDisposition.match(simpleFilenameRegex);

        if (simpleFilenameMatch?.[1]) {
          filename = decodeURIComponent(simpleFilenameMatch[1]);
        }
      }
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    if (autoDownload) {
      download(url, filename);
    }

    return { filename, blob, url };
  } catch (e) {
    const normalizedError = handleFetchError(e);
    return Promise.reject(normalizedError);
  }
};

export const formatFileInfo = ({ fileSize, uploadedAt }: { fileSize: number; uploadedAt: Date }) => {
  const date = uploadedAt ? dateFormat(uploadedAt) : "";
  const size = fileSize !== undefined ? getFileSize(fileSize) : "";
  return `${date}${date && size ? " • " : ""}${size}`;
};
